import { useLocation, useNavigate } from "react-router-dom";
import Subheader from "../todoList/subheader";
import { useEffect, useState } from "react";
import { PostService } from "../../services/genericPostService";
import { resources_EN } from "../componentUtils";
import Swal from "sweetalert2";
import { Path } from "../../RoutesUtils";
import Header from "../header/header";

export default function Edittask() {
  const location = useLocation();
  const [formData, setFormData] = useState({
    presc_comments: "",
    presc_id: "",
    presc_name: "",
    presc_quan: "",
    presc_stock_rem_date: "",
  });
  console.log("Location", location);
  const userId = localStorage.getItem("userId");
  const navigate = useNavigate();

  const token = localStorage.getItem("token");
  useEffect(() => {
    if (!token) {
      navigate(Path.login);
    }
  }, []);

  useEffect(() => {
    if (location.state) {
      const data = location.state;
      console.log("Data", data);
      setFormData((prevState) => ({
        presc_comments: data.presc_comments,
        presc_id: data.presc_id,
        presc_name: data.presc_name,
        presc_quan: data.presc_quan,
        presc_stock_rem_date: data.presc_stock_rem_date,
      }));
    }
  }, []);

  const onChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  /* Submit */
  const submitData = () => {
    const validate = validation();
    if (validate) {
      const data = {
        user_id: userId,
        medicine_title: formData.presc_name,
        medicine_quantity: formData.presc_quan,
        reminder_date: formData.presc_stock_rem_date,
        comments: formData.presc_comments,
        prescription_id: formData.presc_id,
      };
      const url = "/fmeApi/update_medicine_prescription.php";
      PostService(url, data, modal);
    }
  };

  const modal = (icon, title, message) => {
    Swal.fire({
      icon: icon,
      title: title,
      text: message,
    }).then((resp) => {
      if (resp.isConfirmed && icon === resources_EN.success) {
        navigate(Path.prescription);
      }
    });
  };

  const validation = () => {
    if (formData.presc_name.trim().length < 1) {
      modal(
        resources_EN.error,
        resources_EN.errorTitle,
        resources_EN.emptyMedTitle
      );
      return false;
    }
    if (formData.presc_stock_rem_date.trim().length < 1) {
      modal(
        resources_EN.error,
        resources_EN.errorTitle,
        resources_EN.emptyMedDate
      );
      return false;
    }
    if (formData.presc_quan.trim().length < 1) {
      modal(
        resources_EN.error,
        resources_EN.errorTitle,
        resources_EN.emptyMedQuantity
      );
      return false;
    }
    if (formData.presc_comments.trim().length < 1) {
      modal(
        resources_EN.error,
        resources_EN.errorTitle,
        resources_EN.emptyMedComments
      );
      return false;
    }
    return true;
  };

  return (
    <>
      <Header />
      <Subheader title="Rediger opgave" />
      <div className="max-w-xl mx-auto lg:px-8 px-4 mt-12 lg:space-y-8 space-y-5 mb-8">
        <div className="space-y-2">
          <label htmlFor="title" className="block text-sm font-medium">
            Medicine Title *
          </label>
          <input
            type="text"
            id="title"
            className="w-full border-b-2 border-gray-300 focus:border-blue-500 focus:outline-none transition duration-300 text-gray-900 text-base py-2"
            placeholder="Enter Task Title"
            name="presc_name"
            value={formData.presc_name}
            onChange={onChange}
          />
        </div>
        <div className="space-y-2">
          <label htmlFor="title" className="block text-sm font-medium">
            Medicine Quantity *
          </label>
          <input
            type="text"
            id="title"
            className="w-full border-b-2 border-gray-300 focus:border-blue-500 focus:outline-none transition duration-300 text-gray-900 text-base py-2"
            placeholder="Enter Med Quantity"
            name="presc_quan"
            onChange={onChange}
            value={formData.presc_quan}
          />
        </div>
        <div className="space-y-2">
          <label htmlFor="title" className="block text-sm font-medium">
            Out of stock reminder date *
          </label>
          <input
            type="date"
            id="title"
            className="w-full border-b-2 border-gray-300 focus:border-blue-500 focus:outline-none transition duration-300 text-gray-900 text-base py-2"
            placeholder="Enter Stock Reminder Date"
            onChange={onChange}
            name="presc_stock_rem_date"
            value={formData.presc_stock_rem_date}
          />
        </div>
        <div className="space-y-2">
          <label htmlFor="description" className="block text-sm font-medium">
            Comments
          </label>
          <textarea
            type="text"
            id="description"
            className="w-full border-b-2 border-gray-300 focus:border-blue-500 focus:outline-none transition duration-300 text-gray-900 text-base py-2"
            placeholder="Enter Comments"
            onChange={onChange}
            name="presc_comments"
            value={formData.presc_comments}
          />
        </div>

        <div className="flex justify-center pt-5">
          <button
            type="button"
            onClick={submitData}
            className="py-1.5 px-16 border border-transparent rounded-full text-sm font-normal text-white bg-theme focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-theme cursor-pointer"
          >
            Save
          </button>
        </div>
      </div>
    </>
  );
}
